// extracted by mini-css-extract-plugin
module.exports = {"url":"PE7NNBpOUWEyjunDogejkw==","thumb":"zzlc8KWLqd9m-h+yp-MUqg==","newsStat":"A-gHhmm42UN8pX+zbILwkA=="};